import {APP_ROOT} from './Configuration';

export const API_ACTION = {
  // DOWNLOAD: "/download",
  // UPLOAD: "/upload",
  // DUPLICATE: "/duplicate",
  // RENAME: "/rename",
  CREATE: '/create',
  UPDATE: '/update',
  DELETE: '/delete',
  MODIFY: '/modify',
  BATCH: '/batch',
  ALL: '/all',
};

export const API_ROOT = APP_ROOT + '/review/api';
/** Software Version */
export const API_SOFTWARE_VERSION = API_ROOT + '/Version/swversion';
/** AuthAction */
export const API_AUTHACTION = API_ROOT + '/AuthAction';
export const API_AUTHACTION_ME = API_AUTHACTION + '/me';
export const API_AUTHACTION_LOGIN = API_AUTHACTION + '/login';
export const API_AUTHACTION_GOOGLELOGIN = API_AUTHACTION + '/googlelogin';
/** AuthRole */
export const API_AUTH_ROLE = API_ROOT + '/AuthRole';
/** AuthRoleActions */
export const API_AUTH_ROLE_ACTIONS_ROLE = API_ROOT + '/AuthRoleActions/role';
/** Company */
export const API_COMPANY = API_ROOT + '/Company';
/** Consolidation */
export const API_CONSOLIDATION = API_ROOT + '/Consolidation';
export const API_CONSOLIDATION_SCORES = API_CONSOLIDATION + '/scores';
export const API_CONSOLIDATION_ROLE_SCORES = API_CONSOLIDATION + '/rolescores';
export const API_POST_CONSOLIDATION_UPDATE_MANUAL_SCORE = API_CONSOLIDATION + '/updatemanualscore';
export const API_POST_CONSOLIDATION_EMPLOYEE_ROLE_LEVEL_UPDATE = API_CONSOLIDATION + '/employeerolelevel/update';
export const API_CONSOLIDATION_DETAIL = API_CONSOLIDATION + '/detail';
export const API_CONSOLIDATION_SAVE_V2 = API_CONSOLIDATION + '/save';
export const API_CONSOLIDATION_FINAL_SCORES = API_CONSOLIDATION + '/finalscores';
export const API_CONSOLIDATION_EXPORT_EXCEL = API_CONSOLIDATION + '/export-excel';
export const API_CONSOLIDATION_EXPORT_CSV = API_CONSOLIDATION + '/exportcsv';
export const API_CONSOLIDATION_EXPORT_PDF = API_CONSOLIDATION + '/export-pdf';
export const API_CONSOLIDATION_EXPORT_PDF_DETAIL = API_CONSOLIDATION + '/export-pdf-detail';
export const API_CONSOLIDATION_IMPORT_EXCEL = API_CONSOLIDATION + '/import-excel';
/** Department */
export const API_DEPARTMENT = API_ROOT + '/Department';
export const API_DEPARTMENT_ALL = API_DEPARTMENT + '/all';
/** Dashboard */
export const API_GET_EMPLOYEE_DASHBOARD = API_ROOT + '/Dashboard/Personal';
export const API_GET_MANAGER_DASHBOARD = API_ROOT + '/Dashboard/Team';
export const API_GET_ADMIN_DASHBOARD = API_ROOT + '/Dashboard/Admin';
export const API_GET_COMPLETE_DATA = API_GET_EMPLOYEE_DASHBOARD + '/CompleteGraphicData';
export const API_GET_LAST_THREE_PERIOD = API_ROOT + '/Dashboard/Reviews';
/** Dropbox Messages */
export const API_MESSAGE = API_ROOT + '/Message';
export const API_MESSAGE_ALL = API_MESSAGE;
export const API_MESSAGE_BY_SENDER = API_MESSAGE_ALL + `/messages/sender`;
export const API_MESSAGE_BY_SENDER_AND_STATUS = (senderId, isRead) =>
  `${API_MESSAGE}/messages/sender/${senderId}/${isRead}`;
export const API_MESSAGE_BY_RECEIVER = API_MESSAGE_ALL + `/messages/receiver`;
export const API_MESSAGE_CREATE = API_MESSAGE + API_ACTION.CREATE;
export const API_MESSAGE_UPDATE = API_MESSAGE + API_ACTION.UPDATE;
export const API_MESSAGE_DELETE = API_MESSAGE + API_ACTION.DELETE;
/** Employee */
export const API_EMPLOYEE = API_ROOT + '/Employee';
export const API_EMPLOYEE_COMPLETE = API_EMPLOYEE + '/AllEmployee';
export const API_EMPLOYEE_BY_ID = API_EMPLOYEE + '/by-id';
export const API_EMPLOYEE_ME = API_EMPLOYEE + '/me';
export const API_EMPLOYEE_ME_PRACTICEMEMBER = API_EMPLOYEE_ME + '/practicemember';
export const API_EMPLOYEE_DEPARTMENT = API_EMPLOYEE + '/department';
export const API_EMPLOYEE_PRACTICE = API_EMPLOYEE + '/practice';
export const API_POST_EMPLOYEE_AUTH = API_EMPLOYEE + '/auth';
export const API_POST_EMPLOYEE_SAUTH = API_EMPLOYEE + '/sauth';
/** EmployeeGenericReview */
export const API_POST_EMPLOYEE_GENERIC_REVIEW = API_ROOT + '/EmployeeGenericReview';
/** EmployeeReview */
export const API_EMPLOYEE_REVIEW = API_ROOT + '/EmployeeReview';
export const API_EMPLOYEE_REVIEW_QUESTIONNAIRE = API_EMPLOYEE_REVIEW + '/{REVIEW_ID}/{DEPARTMENT_ID}/questionnaire';
export const API_EMPLOYEE_REVIEW_MY_REVIEW = API_EMPLOYEE_REVIEW + '/myreview';
export const API_EMPLOYEE_REVIEW_MY_CONSOLIDATE = API_EMPLOYEE_REVIEW + '/myconsolidatedreviews';
export const API_EMPLOYEE_REVIEW_FORME = API_EMPLOYEE_REVIEW + '/forme';
export const API_EMPLOYEE_REVIEW_PROJECT = API_EMPLOYEE_REVIEW + '/project';
export const API_EMPLOYEE_REVIEW_DETAIL = API_EMPLOYEE_REVIEW + '/detail';
export const API_EMPLOYEE_REVIEW_CONSOLIDATION = API_EMPLOYEE_REVIEW + '/consolidation';
export const API_EMPLOYEE_REVIEW_CONSOLIDATION_REPORT = API_EMPLOYEE_REVIEW + '/consolidationreport';
export const API_POST_EMPLOYEE_REVIEW_SYNC_REVIEWER = API_EMPLOYEE_REVIEW + '/syncReviewer';
export const API_POST_EMPLOYEE_REVIEW_SYNC_REVIEWEE = API_EMPLOYEE_REVIEW + '/syncReviewee';
export const API_EMPLOYEE_REVIEW_ENSURE_SELF_REVIEW = API_EMPLOYEE_REVIEW + '/ensureSelfReviews';
export const API_EMPLOYEE_REVIEW_TABLE = API_EMPLOYEE_REVIEW + '/reviewTable';
export const API_EMPLOYEE_REVIEW_OTHERS_REVIEW = API_EMPLOYEE_REVIEW + '/othersreview';
export const API_EMPLOYEE_REVIEW_REVIEWER_ASSIGNMENT = API_EMPLOYEE_REVIEW + '/reviewer_assignment/{PERIOD_ID}';
export const API_EMPLOYEE_REVIEW_REVIEWEE_ASSIGNMENT = API_EMPLOYEE_REVIEW + '/reviewee_assignment/{PERIOD_ID}';
export const API_EMPLOYEE_BULK_REVIEW_TEMPLATE = API_EMPLOYEE_REVIEW + '/bulkreview_template';
export const API_POST_EMPLOYEE_BULK_REVIEW_UPLOAD = API_EMPLOYEE_REVIEW + '/bulkreview_upload';
export const API_EMPLOYEE_REVIEW_SUMMARY = API_EMPLOYEE_REVIEW + '/review_summary';
export const API_EMPLOYEE_REVIEW_SAVE_REVIEW = API_EMPLOYEE_REVIEW + '/saveEmployeeReview';
export const API_CONSOLIDATION_REVIEW_SAVE_REVIEW = API_CONSOLIDATION + '/saveConsolidation';
export const API_UNLOCK_CONSOLIDATION = API_CONSOLIDATION + '/unlock';
/** EmployeeSkill */
export const API_EMPLOYEE_SKILL = API_ROOT + '/EmployeeSkill';
export const API_EMPLOYEE_MY_SKILL = API_EMPLOYEE_SKILL + '/myskill/skill';
export const API_EMPLOYEE_MY_SKILL_GENERIC = API_EMPLOYEE_SKILL + '/myskill/generic';
/** EmployeeSkillReview */
export const API_EMPLOYEE_SKILL_REVIEW = API_ROOT + '/EmployeeSkillReview';
/** Feedback Review */
export const API_FEEDBACK_REVIEW = API_ROOT + '/Feedback';
export const API_FEEDBACK_REVIEW_FORMULATRIX = API_FEEDBACK_REVIEW + '/formulatrix';
export const API_FEEDBACK_REVIEW_LEAD = API_FEEDBACK_REVIEW + '/lead';
/** GenericReviewQuestion */
export const API_GENERIC_REVIEW_QUESTION = API_ROOT + '/GenericReviewQuestion';
export const API_GENERIC_REVIEW_BY_DEPARTEMENT_PERIOD = API_GENERIC_REVIEW_QUESTION + '/questions?departementId=';
export const API_GENERIC_REVIEW_QUESTION_QUESTION = API_GENERIC_REVIEW_QUESTION + '/questions?departmentId=';
/** GeneralQuestionDescription */
export const API_GENERAL_QUESTION_DESCRIPTION = API_ROOT + '/GeneralQuestionDescription';
/** Practice */
export const API_PRACTICE = API_ROOT + '/practice';
/** Project */
export const API_PROJECT = API_ROOT + '/Project';
export const API_PROJECT_LEADS = API_PROJECT + '/leads';
/** ReviewPeriod */
export const API_REVIEW_PERIOD = API_ROOT + '/ReviewPeriod';

/** Role */
export const API_ROLE = API_ROOT + '/Role';
export const API_ROLE_DEPT = API_ROLE + '/dept';
/** RoleLevel */
export const API_ROLE_LEVEL = API_ROOT + '/RoleLevel';
export const API_ROLE_LEVEL_BY_ID = API_ROLE_LEVEL + '/{ROLE_LEVEL_ID}';
export const API_ROLE_LEVEL_BY_PRACTICE = API_ROLE_LEVEL + '/practice/{PRACTICE_ID}';
/** Skill */
export const API_SKILL = API_ROOT + '/Skill';
export const API_SKILL_QUESTIONS = API_SKILL + '/questions';
/** SkillCategory */
export const API_SKILL_CATEGORY = API_ROOT + '/SkillCategory';
export const API_SKILL_CATEGORIES = API_SKILL_CATEGORY + '/categories';
/** TeamProject */
export const API_TEAM_PROJECT = API_ROOT + '/TeamProject';
export const API_TEAM_PROJECT_EMPLOYEE = API_TEAM_PROJECT + '/employee';
export const API_TEAM_PROJECT_ID = API_TEAM_PROJECT + '/{PROJECT_ID}';
export const API_TEAM_PROJECT_ID_EMPLOYEE = API_TEAM_PROJECT_ID + '/employee';
export const API_TEAM_PROJECT_CURRENT_EMPLOYEE = API_TEAM_PROJECT_ID_EMPLOYEE + '/current';
export const API_TEAM_PROJECT_EMPLOYEE_PERIODS = API_TEAM_PROJECT_ID_EMPLOYEE + '/periods';
export const API_TEAM_PROJECT_EMPLOYEE_HISTORY = API_TEAM_PROJECT_ID_EMPLOYEE + '/history';
export const API_TEAM_PROJECT_DEPT_CURRENT_EMPLOYEE = API_TEAM_PROJECT_ID + '/department/{DEPT_ID}/employee/current';
export const API_TEAM_PROJECT_EMPLOYEE_REVIEW_ASSIGNMENTS =
  API_TEAM_PROJECT_ID + '/employeeReviewAssignments/{PERIOD_ID}/all';
export const API_TEAM_PROJECT_EMPLOYEE_REVIEW = API_TEAM_PROJECT_ID + '/employeeReview/{PERIOD_ID}/cons';
export const API_TEAM_PROJECT_EMPLOYEE_PERIOD = API_TEAM_PROJECT + '/employee/{EMPLOYEE_ID}/period/{PERIOD_ID}';

